import { render, staticRenderFns } from "./generic-modal.html?vue&type=template&id=4c384e5a&scoped=true&external"
import script from "./generic-modal.js?vue&type=script&lang=js&external"
export * from "./generic-modal.js?vue&type=script&lang=js&external"
import style0 from "./generic-modal.scss?vue&type=style&index=0&id=4c384e5a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c384e5a",
  null
  
)

export default component.exports